import type { ReactNode } from 'react';
import ContactsPanel from './ContactsPanel';
import type { TablemaintRow } from '../../services/tablemaint.service';

/**
 * Per-table child subtables rendered inside the GENERIC drawer, keyed by registry
 * `key`. <TablemaintPage> passes the matching entry as <TablemaintDrawer renderPanels>.
 *
 * This is the lightweight half of what CUSTOM_DRAWERS used to be for. A table whose
 * only non-generic need is a subtable (contacts, documents, line items) belongs here
 * — it keeps the generic form, validation, save and soft-delete, and adds just the
 * panel. Reach for CUSTOM_DRAWERS only when the FORM itself can't be expressed by
 * the field specs.
 *
 * Panels persist themselves (they own their own CRUD), so they are independent of
 * the drawer's Save button.
 */
export const DRAWER_PANELS: Record<string, (row: TablemaintRow) => ReactNode> = {
  // AP vendors: identity is read-only (managed in Sage); contacts are the only
  // editable child data. Keyed by tablename/recno like every contactinfo subtable.
  vendors: (row) => <ContactsPanel tablename="vendors" recno={Number(row.recno)} />,
};
